import PropTypes from "prop-types"
import { forwardRef } from "react"

import { useFetchPreviewMedia } from "hooks/useFetchPreviewMedia"

import editorStyles from "styles/isomer-cms/pages/Editor.module.scss"

import { getClassNames } from "templates/utils/stylingUtils"

/* eslint
  react/no-array-index-key: 0
 */

const TemplateInfopicRightSection = (
  { title, subtitle, description, button, sectionIndex, imageUrl, imageAlt },
  ref
) => {
  const addDefaultSrc = (e) => {
    e.target.src = "/placeholder_no_image.png"
  }

  const loadedImageURL = useFetchPreviewMedia(imageUrl)

  return (
    <div ref={ref}>
      <section
        className={getClassNames(editorStyles, [
          `bp-section`,
          sectionIndex % 2 === 1 ? "bg-newssection" : null,
        ])}
      >
        <div className={editorStyles["bp-container"]}>
          {/* For mobile */}
          <div
            className={getClassNames(editorStyles, [
              "row",
              "is-hidden-desktop",
              "is-hidden-tablet-only",
            ])}
          >
            <div
              className={getClassNames(editorStyles, [
                "col",
                "is-half",
                "padding--bottom",
              ])}
            >
              <p
                className={getClassNames(editorStyles, [
                  "padding--bottom",
                  "eyebrow",
                  "is-uppercase",
                ])}
              >
                {subtitle}
              </p>
              <h1
                className={getClassNames(editorStyles, [
                  "padding--bottom",
                  "has-text-secondary",
                  "h1",
                ])}
              >
                {title}
              </h1>
              <p className={getClassNames(editorStyles, ["body-1"])}>
                {description}
              </p>
              <div
                className={getClassNames(editorStyles, [
                  "py-4",
                  "link-button",
                  "remove-after",
                  "is-flex",
                  "flex-start",
                  "is-vh-centered",
                ])}
              >
                {button ? (
                  <div>
                    <span
                      className={getClassNames(editorStyles, [
                        "link-button-text",
                      ])}
                    >
                      {button}
                    </span>
                    <i
                      className={getClassNames(editorStyles, [
                        "sgds-icon",
                        "sgds-icon-arrow-right",
                        "is-size-4",
                        "ml-3",
                      ])}
                      aria-hidden="true"
                    />
                  </div>
                ) : null}
              </div>
            </div>
            <div className={getClassNames(editorStyles, ["col", "is-half"])}>
              <img
                onError={addDefaultSrc}
                src={loadedImageURL}
                alt={imageAlt}
              />
            </div>
          </div>
          {/* For tablet */}
          <div
            className={getClassNames(editorStyles, [
              "row",
              "is-hidden-mobile",
              "is-hidden-desktop",
            ])}
          >
            <div
              className={getClassNames(editorStyles, [
                "col",
                "is-half",
                "padding--top--xl",
                "padding--bottom--xl",
              ])}
            >
              <img
                onError={addDefaultSrc}
                src={loadedImageURL}
                alt={imageAlt}
              />
            </div>
            <div className={getClassNames(editorStyles, ["col", "is-half"])}>
              <p
                className={getClassNames(editorStyles, [
                  "padding--bottom",
                  "subtitle-2",
                ])}
              >
                {subtitle}
              </p>
              <h1
                className={getClassNames(editorStyles, [
                  "padding--bottom",
                  "has-text-secondary",
                  "h1",
                ])}
              >
                {title}
              </h1>
              <p className={getClassNames(editorStyles, ["body-1"])}>
                {description}
              </p>
              <div
                className={getClassNames(editorStyles, [
                  "py-4",
                  "link-button",
                  "remove-after",
                  "is-flex",
                  "flex-start",
                  "is-vh-centered",
                ])}
              >
                {button ? (
                  <>
                    <span
                      className={getClassNames(editorStyles, [
                        "link-button-text",
                      ])}
                    >
                      {button}
                    </span>
                    <i
                      className={getClassNames(editorStyles, [
                        "sgds-icon",
                        "sgds-icon-arrow-right",
                        "is-size-4",
                        "ml-3",
                      ])}
                      aria-hidden="true"
                    />
                  </>
                ) : null}
              </div>
            </div>
          </div>
          {/* For desktop */}
          <div
            className={getClassNames(editorStyles, [
              "row",
              "is-hidden-mobile",
              "is-hidden-tablet-only",
            ])}
          >
            <div
              className={getClassNames(editorStyles, [
                "col",
                "is-half",
                "padding--top--xl",
                "padding--bottom--xl",
              ])}
            >
              <img
                onError={addDefaultSrc}
                src={loadedImageURL}
                alt={imageAlt}
              />
            </div>
            <div
              className={getClassNames(editorStyles, [
                "col",
                "is-half",
                "padding--top--xl",
                "padding--bottom--xl",
                "padding--left--xl",
                "padding--right--xl",
              ])}
            >
              <p
                className={getClassNames(editorStyles, [
                  "padding--bottom",
                  "eyebrow",
                  "is-uppercase",
                ])}
              >
                {subtitle}
              </p>
              <h1
                className={getClassNames(editorStyles, [
                  "padding--bottom",
                  "has-text-secondary",
                  "h1",
                ])}
              >
                {title}
              </h1>
              <p className={getClassNames(editorStyles, ["body-1"])}>
                {description}
              </p>
              <div
                className={getClassNames(editorStyles, [
                  "py-4",
                  "link-button",
                  "remove-after",
                  "is-flex",
                  "flex-start",
                  "is-vh-centered",
                ])}
              >
                {button ? (
                  <>
                    <span
                      className={getClassNames(editorStyles, [
                        "link-button-text",
                      ])}
                    >
                      {button}
                    </span>
                    <i
                      className={getClassNames(editorStyles, [
                        "sgds-icon",
                        "sgds-icon-arrow-right",
                        "is-size-4",
                        "ml-3",
                      ])}
                      aria-hidden="true"
                    />
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default forwardRef(TemplateInfopicRightSection)

TemplateInfopicRightSection.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  button: PropTypes.string,
  imageUrl: PropTypes.string,
  imageAlt: PropTypes.string,
  sectionIndex: PropTypes.number.isRequired,
}

TemplateInfopicRightSection.defaultProps = {
  title: undefined,
  subtitle: undefined,
  description: undefined,
}
